export const EMPTY_STRING = '';
export const WHITESPACE = ' ';
export const DOT = '.';
export const LINE_BREAK = '<br/>';
export const ELLIPSIS = '...';
export const DASH = '-';
export const LOWER_THAN = '<';
export const EQUAL = '=';
export const PERCENT = '%';
export const ASTERISK = '*';
export const CARET = '^';
export const DEFAULT_TRUNCATION_LIMIT = 30;
export const DEFAULT_HIGHLIGHT_CONTEXT_LENGTH = 75;
export const MINIMUM = 'Min';
export const MAXIMUM = 'Max';
export const MINIMUM_DISPLAYED_VALUE = 0.01;
export const MAXIMUM_DISPLAYED_VALUE = 1000;
export const MAXIMUM_DISPLAYED_RANGE_VALUE = 100;
export const DEFAULT_DECIMAL_DIGITS = 2;
export const CURRENT_YEAR: number = new Date().getFullYear();
export const US_LOCALE = 'en-US';
export const NOT_AVAILABLE = 'n/a';
export const BETA_TEXT = 'BETA';
export const PROCEED_TEXT = 'Proceed';
export const SAVE_TEXT = 'Save';
export const SORT_BY_LABEL = 'Sort by ';
export const CANCEL_TEXT = 'Cancel';
export const REMOVE_TEXT = 'Remove';
export const DELETE_TEXT = 'Delete';
export const UPLOAD_TEXT = 'Upload';
export const SUBMIT_TEXT = 'Submit';
export const CONFIRM_TEXT = 'Confirm';
export const CONTINUE_TEXT = 'Continue';
export const WELCOME_TEXT = 'Welcome to';
export const MESSAGE_TEXT = 'Message';
export const TABLE_TEXT = 'Table';
export const THE = 'the';
export const WELCOME_TEXT_DEFINITE = `${WELCOME_TEXT} ${THE}`;
export const AND_THE = ` and ${THE} `;
export const FROZEN_COLUMN_CLASS_NAME = '.datatable-row-left';
export const TABLE_HEADER_HEIGHT = 50;
export const TABLE_ROW_HEIGHT = 49;
export const NO_OP_CALLBACK: () => void = (): void => {};
export const TOOLTIP_OPEN_DELAY = 500;
export const FORM_CLEAR_BUTTON_CLASS = 'fa-xmark';
export const FORM_EXPAND_BUTTON_CLASS = 'fa-ellipsis';
export const FORM_CIRCULAR_CLEAR_BUTTON_CLASS = 'fa-circle-xmark';
export const ADD_DIALOG_ICON_CLASS = 'fa-solid fa-circle-plus';
export const REDO_DIALOG_ICON_CLASS = 'fa-solid fa-rotate-right';
export const UNDO_DIALOG_ICON_CLASS = 'fa-solid fa-arrow-u-turn-down-left';
export const EDIT_DIALOG_ICON_CLASS = 'fa-solid fa-pen-circle';
export const UNSAVED_CHANGES_ICON_CLASS = 'fa-solid fa-floppy-disk-circle-xmark';
export const DOI_URL = 'https://doi.org/';
export const REFERENCE_TAG = 'ref';
export const DELETE_CONFIRMATION_TEXT = 'Yes, delete it';
export const DELETE_CANCEL_TEXT = 'No, keep it';
export const OUT_OF = 'out of';
export const ET_AL = 'et al.';
export const NUMBER_WORDS: string[] = ['zero', 'one', 'two', 'three', 'four', 'five'];
export const DEFAULT_DATE_FORMAT = 'dd MMM yyyy HH:mm:ss';
export const DATE_TIME_FORMAT = 'dd MMM yyyy HH:mm';
export const TIME_FORMAT = 'HH:mm';
export const BYTES_PER_KILOBYTE = 1024; // in binary format
export const BYTES_PER_MEGABYTE: number = Math.pow(BYTES_PER_KILOBYTE, 2);
export const MS_PER_SECOND = 1000;
export const MS_PER_MINUTE: number = 60 * MS_PER_SECOND;
export const MS_PER_HOUR: number = 60 * MS_PER_MINUTE;
export const MS_PER_DAY: number = 24 * MS_PER_HOUR;
export const MS_PER_WEEK: number = 7 * MS_PER_DAY;
export const MS_PER_MONTH: number = 30 * MS_PER_DAY;
export const MS_PER_YEAR: number = 365 * MS_PER_DAY;
export const EXTERNAL_LINK_ICON_CLASS = 'fa-solid fa-arrow-up-right-from-square';
export const COMING_SOON_ICON_CLASS = 'fa-solid fa-hourglass-clock';
